// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentPatientLookupRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentPatientLookupRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentPatientLookupRequestModel.discriminator = undefined;
ExtEnrollmentPatientLookupRequestModel.additionalProperties = false;
ExtEnrollmentPatientLookupRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentPatientLookupRequestModel.js.map